import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './config/firebase';
import './App.css';
import Header from './components/Header';
import Home from './pages/Home';
import ServiceProviderList from './pages/ServiceProviderList';
import ServiceProviderProfile from './pages/ServiceProviderProfile';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './components/admin/AdminLogin';
import BusinessPortal from './components/business/BusinessPortal';
import { QueryClient, QueryClientProvider } from 'react-query';
import FeedbackForm from './components/feedback/FeedbackForm';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// Admin Route Guard Component
const AdminRoute = ({ children }) => {
  const isAdmin = auth.currentUser?.email === 'admin@aroundu.co.za';
  return isAdmin ? children : <Navigate to="/admin/login" />;
};

const App = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAdmin(user?.email === 'admin@aroundu.co.za');
      setLoading(false);
    });

    // Google Analytics setup
    const handleRouteChange = () => {
      if (window.gtag) {
        window.gtag('config', 'G-TT0R09FKWN', {
          page_path: window.location.pathname
        });
      }
    };

    handleRouteChange();
    window.addEventListener('popstate', handleRouteChange);

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      unsubscribe();
    };
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App">
          <Header isAdmin={isAdmin} />
          <div className="content">
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Home />} />
              <Route path="/providers" element={<ServiceProviderList />} />
              <Route path="/providers/:providerId" element={<ServiceProviderProfile />} />
              <Route path="/business" element={<BusinessPortal />} />

              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route 
                path="/admin/*" 
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                } 
              />

              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
          <FeedbackForm />
        </div>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
